






import { Component, Vue } from "vue-property-decorator";

import Menu from "@/components/Menu.vue";

import menuData from "@/data/menu.json";

import { MenuItem } from "@/types";

@Component({
  components: {
    Menu,
  },
})
export default class App extends Vue {
  menuList: Array<MenuItem> = menuData;
}
